// extracted by mini-css-extract-plugin
export var filterIncDec = "_d2-0";
export var leftBorder = "_d2-1";
export var rightBorder = "_d2-2";
export var stringInput = "_d2-3";